import * as React from "react";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import WebIcon from "@mui/icons-material/Web";
import BusinessIcon from "@mui/icons-material/Business";
import EventIcon from "@mui/icons-material/Event";
import LockIcon from "@mui/icons-material/Lock";
import SettingsIcon from "@mui/icons-material/Settings";

/** Sidebar metadata for Admin Documentation (id must match topic URL and topic component map). */
export const DOC_SECTIONS = [
  { id: "organizations", title: "Organizations", icon: <BusinessIcon /> },
  { id: "auth0", title: "Auth0 & sign-in", icon: <LockIcon /> },
  { id: "circle-events", title: "Circle (events)", icon: <EventIcon /> },
  { id: "subscriptions", title: "Subscriptions", icon: <SubscriptionsIcon /> },
  { id: "squarespace-website", title: "Squarespace Website", icon: <WebIcon /> },
  { id: "api-environment", title: "API Environment", icon: <SettingsIcon /> },
];
